import React from 'react';
import { BooleanSettings } from 'modules/settingsContainer/common/BooleanSettings';
import { BooleanSettingsControlInterface } from 'modules/settingsContainer/common/BooleanSettings/types';

type MakeHyperLinksSettingsProps = Required<BooleanSettingsControlInterface>;

export const MakeHyperLinksSettings = ({ value, onChange }: MakeHyperLinksSettingsProps) => {
  return <BooleanSettings titleText="Сделать гиперссылками" value={value} onChange={onChange} />;
};
